import type { FC } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { links } from '~/links.js'
import type { PieceForSearch, SearchResult } from '~/search/model/search.js'
import { SearchResultListItem, type SearchResultProps } from './SearchResultListItem.js'
import { SearchResultSecondaryText } from './SearchResultSecondaryText.js'
import { HighlightedText } from './HighlightedText.js'

type Props = SearchResultProps<SearchResult<PieceForSearch>>

export const PieceSearchResult: FC<Props> = ({ data }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const { item: piece, matches } = data

  const { addressDescription, senderOrDestination, timeIndicationDisplay } = piece

  const handleOpenClick = () => {
    const { barcode, identifier, printlessCode } = piece
    const isPrintless = printlessCode && !barcode

    const linkFn = isPrintless ? links.trackTraceQRcodeLink : links.trackTraceLink

    navigate(linkFn({ barcode: identifier }), {
      state: {
        addToProfile: false,
        piece,
        referrer: location.pathname,
        origin: 'search',
      },
    })
  }

  return (
    <SearchResultListItem
      key={piece.identifier}
      secondary={
        <>
          <SearchResultSecondaryText>{timeIndicationDisplay}</SearchResultSecondaryText>
          <SearchResultSecondaryText>
            <HighlightedText disableTypography fieldKey="addressDescription" matches={matches}>
              {addressDescription}
            </HighlightedText>
          </SearchResultSecondaryText>
        </>
      }
      primary={
        <HighlightedText emphasis fieldKey="senderOrDestination" matches={matches}>
          {senderOrDestination}
        </HighlightedText>
      }
      onOpen={handleOpenClick}
    />
  )
}
